import { render } from "./JobDetails.vue?vue&type=template&id=0a5073db&scoped=true"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"

import "./JobDetails.vue?vue&type=style&index=0&id=0a5073db&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5073db"]])

export default __exports__